import { Controller } from "@hotwired/stimulus"
import { get, post } from "@lib/requests"
import { Turbo } from "@hotwired/turbo-rails"
import { parse, endOfMonth, isSameDay } from "date-fns"

// Connects to data-controller="invoice-bills"
export default class extends Controller {
  
  static targets = ["endDate", "checkAll", "selectedCount", "submit"]
  
  connect() {
    this.setCheckboxes()
    this.updateSubmitButton()
  }

  setCheckboxes() {
    this.checkboxes = Array.from(this.element.querySelectorAll("tbody [type='checkbox']"))
  }

  get checked() {
    return this.checkboxes.filter(checkbox => checkbox.checked)
  }

  get ids() {
    return this.checked.map(checkbox => checkbox.value)
  }
  
  get noneSelected() {
    return this.checked.length === 0
  }

  get partSelected() {
    return this.checked.length > 0 && !this.allSelected
  }
  
  get allSelected() {
    return this.checked.length === this.checkboxes.length
  }
  
  get hasSelection() {
    return this.checked.length > 0
  }

  // Here we are requesting a turbo stream response
  async update(e) {
    e.preventDefault()
    await post("/comptabilite/bons/recherche", { body: new FormData(this.element), responseKind: "turbo_stream" })
    setTimeout(() => { this.setCheckboxes() }, 300);
  }
  
  updateToggler() {
    if (!this.checkAllTarget) return
    if (this.allSelected) {
      this.checkAllTarget.checked = true
      this.checkAllTarget.indeterminate = false
    } else if (this.partSelected) {
      this.checkAllTarget.indeterminate = true
      this.checkAllTarget.checked = false
    } else {
      this.checkAllTarget.indeterminate = false
      this.checkAllTarget.checked = false
    }
  }

  updateToggleText() {
    this.selectedCountTarget.textContent = this.checked.length
  }

  toggle() {
    this.updateToggler()
    this.updateToggleText()
    this.updateSubmitButton()
  }
  
  selectAll() {
    this.checkboxes.forEach(checkbox => checkbox.checked = true)
    this.checkAllTarget.checked = true
  }

  deselectAll() {
    this.checkboxes.forEach(checkbox => checkbox.checked = false)
    this.checkAllTarget.checked = false
  }
  
  toggleAll(event) {
    this.noneSelected || this.partSelected ? this.selectAll() : this.deselectAll()
    this.updateToggleText()
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    this.submitTarget.disabled = !this.hasSelection
  }

  async submitForm(e) {
    e.preventDefault()
    
    if (!this.hasSelection) return

    // Disable the submit button
    this.submitTarget.disabled = true

    // Send a GET request to invoice_preview_bills_path
    const url = new URL("/comptabilite/bons/invoice_preview", window.location.origin)
    
    // Append the ids[] to the URL
    this.ids.forEach((id) => url.searchParams.append("ids[]", id))

    // Create a summary with eg: février 2025 (the month and year of the end_date)
    const dateString = this.endDateTarget.value // Returns like '28/02/2025'
    const endDate = parse(dateString, "dd/MM/yyyy", new Date())

    const isLastDayOfMonth = isSameDay(endOfMonth(endDate), endDate)
    
    const summary = isLastDayOfMonth 
      ? endDate.toLocaleString("fr-FR", { month: "long", year: "numeric" }) 
      : `- ${dateString}`

    url.searchParams.append("summary", summary)

    // Call the invoice_preview action
    await get(url.href, { responseKind: "turbo_stream" })

    // Wait a beat before enabling the submit button
    setTimeout(() => {
      this.submitTarget.disabled = false
    }, 1000)

  }

}
